<template>
  <div class="order-flag-button">
    <button
      type="button"
      @click="openForm"
      class="h-8 flex flex-no-wrap items-center gap-2"
      :class="{
        'red-button': flag,
        'dark-button': !flag
      }"
    >
      <span v-if="flag">Remove Flag</span>
      <span v-else>Add Flag</span>
      <img
        class="w-6 h-6 flex-shrink-0"
        src="img/api/menu-icons/flag.svg"
        alt="flag"
      />
    </button>
    <BaseModal @input="showForm = false" :value="showForm">
      <div class="p-4">
        <h2 class="font-bold">
          {{ flag ? "Remove current flag" : "Add new flag" }}
        </h2>
        <div class="flex flex-col">
          <BaseSmallSpinner v-if="loading" class="mt-4" />
          <form @submit.prevent="createFlag" v-else>
            <textarea
              autofocus
              id="flag-comment"
              ref="flagComment"
              placeholder="Flag comment"
              v-model="comment"
              class="p-2 mt-10 w-full"
            ></textarea>
            <button class="dark-button mt-2 flex w-min whitespace-nowrap">
              {{ flag ? "Remove flag" : "Add Flag" }}
            </button>
          </form>
        </div>
      </div>
    </BaseModal>
  </div>
</template>
<script>
import { createOrderFlag } from "@/api/Orders";
export default {
  name: "OrderFlagData",
  props: {
    orderUUID: {
      type: String,
      required: true
    },
    history: {
      type: Array,
      required: true
    },
    flag: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showForm: false,
      comment: "",
      loading: false
    };
  },
  methods: {
    openForm() {
      this.showForm = true;
      this.$nextTick(() => {
        const textArea = this.$refs.flagComment;
        console.log(textArea);
        if (textArea) {
          setTimeout(function() {
            textArea.focus();
          }, 100);
        }
      });
    },
    createFlag() {
      this.loading = true;
      createOrderFlag(this.orderUUID, !this.flag, this.comment)
        .then(() => {
          this.$emit("flagAdded");
          this.showForm = false;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
          this.comment = "";
        });
    }
  }
};
</script>
<style lang="scss">
.order-flag-button {
  .modal {
    padding-top: 100px;
    .modal-content {
      max-width: 600px;
      height: 300px !important;
    }
  }
}
</style>
